export default __webpack_public_path__ + "static/media/topEmployee.ad7b4d64.png";